<div class="container" id="print-section">

  <table style="width:100%;border-collapse:collapse;border:2px solid #000;">

    <!-- Header -->
    <tr>
       <td colspan="5" style="border:2px solid #000;font-weight:bold;font-size:20px;">
      विवेक पुस्तक प्रकाशन
    </td>
       <td colspan="5" style="border:2px solid #000;font-size:18px;font-weight:bold;padding:6px;">
         पुस्तक छपाई आदेश
      </td>
    </tr>

    <!-- Date + Book -->
    <tr>
      <td colspan="4" style="border:2px solid #000;padding:8px;">
        दिनांक :
        <input type="date" [(ngModel)]="adesh_date" style="border:none;width:150px;">
      </td>
      <td colspan="5" style="border:2px solid #000;padding:8px;">
        <input type="text" [(ngModel)]="book_name" placeholder="Book Name" style="width:100%;border:none;font-weight:bold;">
      </td>
    </tr>

    <!-- Publish Date -->
    <tr>
     <td colspan="5" style="border:2px solid #000;padding:8px;font-weight:bold;">
        एकूण प्रती : {{ totalprati }}
      </td>
      <td colspan="4" style="border:2px solid #000;padding:8px;text-align:right;">
        एकूण पृष्ठ :
        <input type="number" [(ngModel)]="totalpsankhya" style="width:80px;">
      </td>
    </tr>

    <!-- Total -->
    <!-- <tr>
      <td colspan="10" style="border:2px solid #000;padding:8px;font-weight:bold;">
        एकूण प्रती : {{ totalprati }}
      </td>
    </tr> -->

    <!-- Column Header -->
    <tr style="background:#f3f3f3;font-weight:bold;">
      <td style="border:2px solid #000;">क्रमांक</td>
      <td colspan="3" style="border:2px solid #000;">विगत</td>
      <td colspan="2" style="border:2px solid #000;">प्रती</td>
      <!-- <td colspan="3" style="border:2px solid #000;">शेरा</td> -->
      <!-- <td style="border:2px solid #000;">Action</td> -->
    </tr>

    <!-- Data Rows -->
    <tr *ngFor="let item of tempdata; let i=index">

      <td style="border:2px solid #000;text-align:center;">
        {{ i + 1 }}
      </td>
<td colspan="3" style="border:2px solid #000;">
  <input
    type="text"
    [(ngModel)]="item.name"
    style="
      width:100%;
      border:none;
      outline:none;
      background:transparent;
    ">
</td>

      <td colspan="2" style="border:2px solid #000;">
        <input
          type="number"
          [(ngModel)]="item.prati"
          (keyup)="calculateTotal()"
          style="width:80px;">
      </td>

      <!-- <td colspan="3" style="border:2px solid #000;">
        <input
          type="text"
          [(ngModel)]="item.shera"
          style="width:100%;border:none;">
      </td> -->
<!-- 
      <td style="border:2px solid #000;text-align:center;">
        <button mat-icon-button color="warn" (click)="removeRow(i)">✖</button>
      </td> -->

    </tr>
      <tr style="background:#f2f2f2;">
      <td colspan="4" style="border:2px solid #000;font-weight:bold;">
        एकूण
      </td>
      <td colspan="2" style="border:2px solid #000;font-weight:bold;">
        {{ totalprati }}
      </td>
      <!-- <td colspan="4" style="border:2px solid #000;"></td> -->
    </tr>

    <!-- Footer -->
    <tr>
      <td colspan="9" style="border:2px solid #000;text-align:center;padding:10px;">
        <button mat-raised-button color="primary" (click)="addRow()">Add Row</button>
      </td>
    </tr>

  </table>

</div>

<div style="margin-top:15px;text-align:right;">

  <button mat-raised-button color="accent" ngxPrint printSectionId="print-section">
    Print
  </button>

  &nbsp;

  <button mat-raised-button color="warn" (click)="closeDialog()">
    Close
  </button>
  <button mat-raised-button color="primary" (click)="updateOrder()">
  Update
</button>

</div>